import PropTypes from "prop-types";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { addEditVillage } from "../../Redux/Slices/villageSlice"
import toast from "react-hot-toast";
import { districtWopList } from "../../Redux/Slices/districtSlice";
import { talukaWopList } from "../../Redux/Slices/talukaSlice";

const AddEditVillage = ({ isOpen, onClose, rowData }) => {

  const initialValues = {
    _id: "",
    districtId: "",
    talukaId: "",
    code: "",
    english_name: "",
    gujarati_name: "",
  };
  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const dispatch = useDispatch();

  const [formikInitialValue, setFormikInitialValue] = useState(initialValues);

  const validationSchema = Yup.object().shape({
    // english_name: Yup.string().required("Relation name in English is required"),
    // gujarati_name: Yup.string().required("Relation name in Gujarati is required"),
  });
  const getDistricts = async () => {
    try {
      const response = await dispatch(districtWopList()).unwrap();
      if (response.IsSuccess) {
        setDistricts(response.Data || []);
        // getTalukas();
      }
    } catch (error) {
      toast.error("Failed to fetch districts");
    }
  };

  const getTalukas = async (districtId) => {
    try {
      const response = await dispatch(talukaWopList({ districtId })).unwrap();
      if (response.IsSuccess) {
        const filteredTalukas = response.Data.filter(taluka =>
          taluka.districtId?._id === districtId
      );
      setTalukas(filteredTalukas || []);
      }
    } catch (error) {
      toast.error("Failed to fetch talukas");
    }
  };

  useEffect(() => {
    getDistricts();
    if (rowData) {
      setFormikInitialValue({
        _id: rowData?._id || '',
        districtId: rowData?.districtId?._id || '',
        talukaId: rowData?.talukaId?._id || '',
        code: rowData?.code || '',
        english_name: rowData?.english_name || "",
        gujarati_name: rowData?.gujarati_name || "",
      });
      if (rowData?.districtId?._id) {
        getTalukas(rowData.districtId._id);
      }
    } else {
      setFormikInitialValue(initialValues);
    }
  }, [rowData]);

  const handleGujaratiChange = (e, setFieldValue) => {
    const { name, value } = e.target;

    const gujaratiOnly = /^[\u0A80-\u0AFF\d\s]*$/;

    if (value === "" || gujaratiOnly.test(value)) {
      setFieldValue(name, value);
    }
  };

  const handleSubmit = async (values) => {
    const payload = {
      ...values,
      _id: values?._id || "",
      districtId: values?.districtId || "",
      talukaId: values?.talukaId || '',
      english_name: values?.english_name || "",
      gujarati_name: values?.gujarati_name || "",
    }
    const response = await dispatch(addEditVillage(payload)).unwrap();
    if (response.IsSuccess) {
      toast.success(response.Message);
      //   navigate("/occupations");
    }
    onClose();
  };

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="fixed inset-0 bg-black opacity-50 backdrop-blur-lg"></div>

      <div className="flex items-center justify-center min-h-screen p-4">
        <div className="relative bg-white rounded-3xl shadow-xl max-w-4xl w-full p-3 md:p-7">
          <div className="flex items-center justify-between p-4">
            <h3 className="text-18 lg:text-26 font-bold text-gray-900">Add Village</h3>
            <button
              onClick={onClose}
              className="hover:text-text_1"
            >
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <Formik
            initialValues={formikInitialValue}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {({ isSubmitting, setFieldValue }) => (
              <Form className="p-4">
                <div className="w-full mb-3 md:mb-5">
                  <label className="block text-16 font-semibold text-text_2">
                    Village Code
                  </label>
                  <Field
                    name="code"
                    type="text"
                    className="mt-1 block w-full rounded-md px-3 py-2 bg-[#EEEEEE] focus:outline-none"
                  />
                </div>
                <div className="md:flex gap-4 mb-3 md:mb-5">
                  <div className="w-full md:w-1/2">
                    <label htmlFor="districtId" className="block text-14 md:text-16 font-bold text-text_2 mb-1">
                      District
                    </label>
                    <Field
                      as="select"
                      id="districtId"
                      name="districtId"
                      className="w-full px-3 py-2.5 bg-[#EEEEEE] rounded-md"
                      onChange={(e) => {
                        const districtId = e.target.value;
                        setFieldValue("districtId", districtId);
                        setFieldValue("talukaId", ""); // Reset taluka
                        setFieldValue("villageId", ""); // Reset village
                        setTalukas([]); // Clear taluka list
                        if (districtId) {
                          getTalukas(districtId);
                        }
                      }}
                    >
                      <option value="">Select District</option>
                      {districts.map((item) => (
                        <option key={item?._id} value={item?._id}>
                          {item?.gujarati_name}
                        </option>
                      ))}
                    </Field>
                  </div>
                  <div className="w-full md:w-1/2">
                    <label htmlFor="talukaId" className="block text-14 md:text-16 font-bold text-text_2 mb-1">
                      Taluka
                    </label>
                    <Field
                      as="select"
                      id="talukaId"
                      name="talukaId"
                      className="w-full px-3 py-2.5 bg-[#EEEEEE] rounded-md"
                    >
                      <option value="">Select Taluka</option>
                      {talukas.map((item) => (
                        <option key={item?._id} value={item?._id}>
                          {item?.gujarati_name}
                        </option>
                      ))}
                    </Field>
                  </div>
                </div>
                <div className="md:flex gap-4 mb-3 md:mb-5">
                  <div className="w-full md:w-1/2">
                    <label className="block text-16 font-semibold text-text_2">
                      Village Name (English)
                    </label>
                    <Field
                      name="english_name"
                      type="text"
                      className="mt-1 block w-full rounded-md px-3 py-2 bg-[#EEEEEE] focus:outline-none"
                    />
                  </div>
                  <div className="w-full md:w-1/2">
                    <label className="block text-16 font-semibold text-text_2">
                      Village Name (Gujarati)
                    </label>
                    <Field
                      name="gujarati_name"
                      type="text"
                      className="mt-1 block w-full rounded-md px-3 py-2 bg-[#EEEEEE] focus:outline-none"
                      onChange={(e) => handleGujaratiChange(e, setFieldValue)}
                    />
                  </div>
                </div>
                <div className="flex items-center justify-center p-4 space-x-3 xl:space-x-5">
                <button
                    type="button"
                    onClick={onClose}
                    className="btn_secondary">
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="btn py-2.5 md:py-3.5 px-8 md:px-12"
                  >
                    {isSubmitting ? "Submitting..." : "Save"}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  )
}
AddEditVillage.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  rowData: PropTypes.object,
  getVillageListFun: PropTypes.func,
  children: PropTypes.any,
};

export default AddEditVillage;